// extracted by mini-css-extract-plugin
export var cardIcon = "_4i-4";
export var checkboxCard = "_4i-0";
export var checkboxCardSelected = "_4i-1";
export var disabled = "_4i-2";
export var outerBorder = "_4i-3";
export var spacerMedium = "_4i-7";
export var spacerSmall = "_4i-6";
export var spacerXsmall = "_4i-5";